import * as React from "react";
import { IconButton } from "@grandvisionhq/iris-ui";
/* empty css                    */
const ExpanderToggle = ({ label, isExpanded, onToggleClick }) => /* @__PURE__ */ React.createElement(
  IconButton,
  {
    variant: "outline",
    onPress: onToggleClick,
    "aria-expanded": isExpanded,
    "aria-label": label,
    "data-t": "expander-toggle",
    className: "configurator-footer-expander-toggle",
    icon: "ChevronUp"
  }
);
export {
  ExpanderToggle
};
//# sourceMappingURL=ExpanderToggle.js.map
